/**
 * Strip the query string from a URL. Search/filter endpoints carry PHI in query
 * params (e.g. `…/linkable-records?q=<patient name>`), so the path is safe to
 * keep for observability but the query string is not. Used both when annotating
 * API errors (see `ApiError` in apiClient.ts) and when scrubbing Sentry events
 * (see sentry.config.ts).
 */
export function stripQueryString(url: string | undefined): string | undefined {
  if (!url) return url;
  const queryIndex = url.indexOf('?');
  return queryIndex === -1 ? url : url.slice(0, queryIndex);
}
